import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import {
  Container,
  TextField,
  Checkbox,
  FormControlLabel,
  Typography,
  Grid,
  Paper,
  Box,
  Button,
  Alert,
  MenuItem,
  Divider,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions, Autocomplete,
  IconButton,
  Input,
  InputLabel,
  FormControl,
  Select,
  ListSubheader,
  FormHelperText

} from "@mui/material";
import SignatureCanvas from 'react-signature-canvas';
import { fromUnixTime } from "date-fns";
import ShareIcon from '@mui/icons-material/Share';
import LocalHospital from '@mui/icons-material/LocalHospital';
import { API_BASE_URL } from '../../lib/constants';
import theme from '../../theme/theme';
import { ThemeProvider } from '@mui/material/styles';
import { useNotification } from '../../contexts/NotificationContext';
import DraftSaveButton from '../../components/DraftSaveButton';
import { DRAFT_KEYS, loadDraft, hasDraft, clearDraft } from '../../utils/draftUtils';
const AnaesthesiaConsentForm = () => {
  const { showNotification } = useNotification();
  const navigate = useNavigate();
  const { uhid_no } = useParams(); // Extract uhid_no directly from params
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [errors, setErrors] = useState('');


  const [formData, setFormData] = useState(() => ({
    ip_no: '',
    uhid_no: uhid_no || '', // Initialize with uhid_no from params
    patient_name: '',
    age: '',
    sex: '',
    consultant: '',
    ward_bed_no: '',
    acknowledge_patient_name: '',
    anaesthesia_care_plan: '',
    general_anaesthesia: false,
    spinal_epidural_with_sedation: false,
    spinal_epidural_without_sedation: false,
    major_minor_nerve_with_sedation: false,
    major_minor_nerve_without_sedation: false,
    dr_name: '',
    dr_his_her: '',
    patient_signature: '',
    patient_signature_name: '',
    patient_signature_date_time: '',
    witness_signature: '',
    witness_name: '',
    witness_signature_date_time: '',
    doctor_anaesthetist_signature: '',
    doctor_anaesthetist_signature_date_time: '',
    interpreter_signature: '',
    interpreter_name: '',
    interpreter_signature_date_time: '',
    unable_consent_reason: '',
    attender_name: '',
    patient_rep_signature: '',
    patient_rep_signature_date_time: '',
    patient_rep_witness_signature: '',
    patient_rep_witness_name: '',
    patient_rep_witness_date_time: '',
    patient_rep_doctor_anaesthetist_sign: '',
    patient_rep_doctor_anaesthetist_sign_date_time: '',
    patient_rep_interpreter_signature: '',
    patient_rep_interpreter_name: '',
    patient_rep_interpreter_signature_date_time: '',
    doctor_anaesthetist_name: '',
    patient_rep_name: '',
    patient_rep_doctor_anaesthetist_name: ''
  }));
  const handleChange = (event) => {
    const { name, type, checked } = event.target;
    let value = type === 'checkbox' ? checked : event.target.value;


    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    let error = "";

    switch (name) {
      case 'consultant':
        if (!value) error = "Consultant is required";
        break;
      case 'anaesthesia_care_plan':
        if (!value) error = "Care plan is required";
        break;
      case 'dr_name':
        if (!value || !value.trim()) error = "Doctor name is required";
        break;
      default:
        break;
    }

    if (error) {
      setErrors((prev) => ({ ...prev, [name]: error }));
    }
  };

  const handleNameChange = (e) => {
    const regex = /^[a-zA-Z\s.-]*$/; // allow letters, spaces, dot, hyphen
    const value = e.target.value;
    if (value === '' || regex.test(value)) {
      setFormData({ ...formData, [e.target.name]: value });

      if (errors[e.target.name]) {
        setErrors((prev) => ({ ...prev, [e.target.name]: '' }));
      }
    }
  };



  const validate = () => {
    const requiredFields = [
      { key: 'consultant',          label: 'Consultant Name'      },
      { key: 'anaesthesia_care_plan',label: 'Anaesthesia Care Plan'},
      { key: 'dr_name',             label: 'Doctor Name'          },
    ];
    const tempErrors = {};
    requiredFields.forEach(({ key, label }) => {
      if (!formData[key] || String(formData[key]).trim() === '')
        tempErrors[key] = `${label} is required`;
    });
    setErrors(tempErrors);
    if (Object.keys(tempErrors).length > 0) {
      setTimeout(() => {
        const firstKey = Object.keys(tempErrors)[0];
        const el = document.querySelector(`[name="${firstKey}"]`);
        if (el) { el.scrollIntoView({ behavior: 'smooth', block: 'center' }); el.focus(); }
      }, 100);
      showNotification('error', requiredFields.filter(f => tempErrors[f.key]).map(f => f.label));
    }
    return Object.keys(tempErrors).length === 0;
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!validate()) return;
    const payload = {
      ip_no: formData.ip_no,
      uhid_no: formData.uhid_no,
      hospital_id: 1,
      patient_name: formData.patient_name,
      age: formData.age,
      sex: formData.sex,
      consultant: formData.consultant,
      ward_bed_no: formData.ward_bed_no,
      acknowledge_patient_name: formData.acknowledge_patient_name,
      anaesthesia_care_plan: formData.anaesthesia_care_plan,
      general_anaesthesia: formData.general_anaesthesia ? 1 : 0,
      spinal_epidural_with_sedation: formData.spinal_epidural_with_sedation ? 1 : 0,
      spinal_epidural_without_sedation: formData.spinal_epidural_without_sedation ? 1 : 0,
      major_minor_nerve_with_sedation: formData.major_minor_nerve_with_sedation ? 1 : 0,
      major_minor_nerve_without_sedation: formData.major_minor_nerve_without_sedation ? 1 : 0,
      dr_name: formData.dr_name,
      dr_his_her: formData.dr_his_her,
      patient_signature: formData.patient_signature,
      patient_signature_name: formData.patient_signature_name,
      patient_signature_date_time: formData.patient_signature_date_time,
      witness_signature: formData.witness_signature,
      witness_name: formData.witness_name,
      witness_signature_date_time: formData.witness_signature_date_time,
      doctor_anaesthetist_signature: formData.doctor_anaesthetist_signature,
      doctor_anaesthetist_signature_date_time: formData.doctor_anaesthetist_signature_date_time,
      interpreter_signature: formData.interpreter_signature,
      interpreter_name: formData.interpreter_name,
      interpreter_signature_date_time: formData.interpreter_signature_date_time,
      unable_consent_reason: formData.unable_consent_reason,
      attender_name: formData.attender_name,
      patient_rep_signature: formData.patient_rep_signature,
      patient_rep_signature_date_time: formData.patient_rep_signature_date_time,
      patient_rep_witness_signature: formData.patient_rep_witness_signature,
      patient_rep_witness_name: formData.patient_rep_witness_name,
      patient_rep_witness_date_time: formData.patient_rep_witness_date_time,
      patient_rep_doctor_anaesthetist_sign: formData.patient_rep_doctor_anaesthetist_sign,
      patient_rep_doctor_anaesthetist_sign_date_time: formData.patient_rep_doctor_anaesthetist_sign_date_time,
      patient_rep_interpreter_signature: formData.patient_rep_interpreter_signature,
      patient_rep_interpreter_name: formData.patient_rep_interpreter_name,
      patient_rep_interpreter_signature_date_time: formData.patient_rep_interpreter_signature_date_time,
      doctor_anaesthetist_name: formData.doctor_anaesthetist_name,
      patient_rep_name: formData.patient_rep_name,
      patient_rep_doctor_anaesthetist_name: formData.patient_rep_doctor_anaesthetist_name,
    };
    console.log(payload);
    try {
      if (success) {
        await axios.put(`${API_BASE_URL}/update_consent/${formData.uhid_no}`, payload);
        showNotification('success', "Consent for Anaesthesia Form updated successfully!");

      } else {
        await axios.post(`${API_BASE_URL}/submit_consent`, payload);
        showNotification('success', "Consent for Anaesthesia Form submitted successfully!");

      }

      clearSavedData();
      navigate(`/mainPage/${uhid_no}`, {
        state: { from: 'PreOperativePhase', status: 'success', step: 1 },
      });
    } catch (error) {
      console.error("There was an error submitting the form!", error);
      setError("Error in submitting form!");
      showNotification('error', "Error in submitting form!");
    }
  };
  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        const [ipRes] = await Promise.all([
          axios.get(`${API_BASE_URL}/consent_next_ip`),


        ]);

        setFormData(prev => ({
          ...prev,

          ip_no: ipRes.data.next_ip_no,
        }));


      } catch (error) {
        console.error('Failed to fetch initial data:', error);
      }
    };

    fetchInitialData();
  }, []);
  const [savedData, setSavedData] = useState(null);
  const [showSaveNotification, setShowSaveNotification] = useState(false);
  const [currentPage, setCurrentPage] = useState('form');
  const [dataLoaded, setDataLoaded] = useState(false);
  // Auto-save functionality
  // Auto-save functionality - only after initial data is loaded
  useEffect(() => {
    if (!dataLoaded) return; // Don't auto-save until initial data is loaded

    const timeoutId = setTimeout(() => {
      if (hasFormData()) {
        saveFormData(formData);
        setShowSaveNotification(true);
        setTimeout(() => setShowSaveNotification(false), 2000);
      }
    }, 2000);

    return () => clearTimeout(timeoutId);
  }, [formData, dataLoaded]);

  // Save form data to sessionStorage
  const saveFormData = (data) => {
    sessionStorage.setItem(`consent_anaesthesiaForm_${uhid_no}`, JSON.stringify(data));
    console.log('Form data saved:', data);
  };

  // Get saved form data
  const getSavedFormData = () => {
    const saved = sessionStorage.getItem(`consent_anaesthesiaForm_${uhid_no}`);
    return saved ? JSON.parse(saved) : null;
  };
  useEffect(() => {
    const saved = getSavedFormData();
    if (saved && Object.keys(saved).length > 0) {
      setSavedData(saved);
      setFormData(saved);
    }
  }, []);
  // Check if form has any data
  const hasFormData = () => {
    return Object.values(formData).some(value => {
      if (typeof value === 'string') return value.trim() !== '';
      if (typeof value === 'object' && value !== null) {
        return Object.values(value).some(subValue =>
          typeof subValue === 'string' ? subValue.trim() !== '' : subValue
        );
      }
      return value === true;
    });
  };

  // Clear saved data - ONLY called on successful submit
  const clearSavedData = () => {
    setSavedData(null);
    sessionStorage.removeItem(`consent_anaesthesiaForm_${uhid_no}`);
    sessionStorage.removeItem(`formStatus_consent_anaesthesia_${uhid_no}`);
  };

  // Home button handler
  const handleHomeNavigation = () => {
    if (hasFormData()) {
      saveFormData(formData);
      // Store form status for home page to show "Continue" button
      sessionStorage.setItem(`formStatus_consent_anaesthesia_${uhid_no}`, JSON.stringify({
        formName: 'CONSENT FOR ANAESTHESIA',
        uhid_no: uhid_no,
        status: 'incomplete',
        lastSaved: new Date().toISOString(),
        continueUrl: `/consentForAnaesthesia/${uhid_no}`
      }));
    }
    navigate('/home');
  };
  const handleBack = () => {
    navigate(`/mainPage/${uhid_no}`, {
      state: { from: 'PreOperativePhase', status: 'success', step: 1 },
    });
  };
  const fetchPatientData = async (uhidNo) => {
    try {
      setLoading(true);
      const response = await axios.get(`${API_BASE_URL}/get_patient/${uhidNo}`);
      console.log(response.data);
      setFormData(prev => ({
        ...prev,

        patient_name: response.data.name,
        age: response.data.age,
        sex: response.data.sex

      }));
      setLoading(false);
    } catch (error) {
      console.error('Error fetching patient data:', error);
      setError('Failed to fetch patient data. Please try again.');
      setLoading(false);
    }
  };
  const unableConsentReasons = [
    "Patient unconscious",
    "Patient sedated",
    "Cognitive impairment",
    "Severe pain or distress",
    "Emergency situation",
    "Language barrier",
    "Hearing impairment",
    "Developmental disability",
    "Under influence of medication or substances",
  ];

  useEffect(() => {
    if (!uhid_no) return;

    const fetchData = async () => {
      try {
        const response = await axios.get(`${API_BASE_URL}/get_consent/${uhid_no}`);

        // Log to inspect the response data structure
        console.log('Fetched Data:', response.data);

        if (response.data && Object.keys(response.data).length > 0) {
          setFormData({
            ip_no: response.data.ip_no || '',
            uhid_no: response.data.uhid_no || '',
            patient_name: response.data.patient_name || '',
            age: response.data.age || '',
            sex: response.data.sex || '',
            consultant: response.data.consultant || '',
            ward_bed_no: response.data.ward_bed_no || '',
            acknowledge_patient_name: response.data.acknowledge_patient_name || '',
            anaesthesia_care_plan: response.data.anaesthesia_care_plan || '',
            general_anaesthesia: response.data.general_anaesthesia || '',
            spinal_epidural_with_sedation: response.data.spinal_epidural_with_sedation || false,
            spinal_epidural_without_sedation: response.data.spinal_epidural_without_sedation || false,
            major_minor_nerve_with_sedation: response.data.major_minor_nerve_with_sedation || false,
            major_minor_nerve_without_sedation: response.data.major_minor_nerve_without_sedation || false,
            dr_name: response.data.dr_name || '',
            dr_his_her: response.data.dr_his_her || '',
            patient_signature: response.data.patient_signature || '',
            patient_signature_name: response.data.patient_signature_name || '',
            patient_signature_date_time: response.data.patient_signature_date_time || '',
            witness_signature: response.data.witness_signature || '',
            witness_name: response.data.witness_name || '',
            witness_signature_date_time: response.data.witness_signature_date_time || '',
            doctor_anaesthetist_signature: response.data.doctor_anaesthetist_signature || '',
            doctor_anaesthetist_signature_date_time: response.data.doctor_anaesthetist_signature_date_time || '',
            interpreter_signature: response.data.interpreter_signature || '',
            interpreter_name: response.data.interpreter_name || '',
            interpreter_signature_date_time: response.data.interpreter_signature_date_time || '',
            unable_consent_reason: response.data.unable_consent_reason || '',
            attender_name: response.data.attender_name || '',
            patient_rep_signature: response.data.patient_rep_signature || '',
            patient_rep_signature_date_time: response.data.patient_rep_signature_date_time || '',
            patient_rep_witness_signature: response.data.patient_rep_witness_signature || '',
            patient_rep_witness_name: response.data.patient_rep_witness_name || '',
            patient_rep_witness_date_time: response.data.patient_rep_witness_date_time || '',
            patient_rep_doctor_anaesthetist_sign: response.data.patient_rep_doctor_anaesthetist_sign || '',
            patient_rep_doctor_anaesthetist_sign_date_time: response.data.patient_rep_doctor_anaesthetist_sign_date_time || '',
            patient_rep_interpreter_signature: response.data.patient_rep_interpreter_signature || '',
            patient_rep_interpreter_name: response.data.patient_rep_interpreter_name || '',
            patient_rep_interpreter_signature_date_time: response.data.patient_rep_interpreter_signature_date_time || '',
            doctor_anaesthetist_name: response.data.doctor_anaesthetist_name || '',
            patient_rep_name: response.data.patient_rep_name || '',
            patient_rep_doctor_anaesthetist_name: response.data.patient_rep_doctor_anaesthetist_name || '',
          });
          setSuccess(true);
        } else {
          setFormData(prevData => ({ ...prevData, uhid_no }));
          setSuccess(false);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        setFormData(prevData => ({ ...prevData, uhid_no }));
        setSuccess(false);
      }
    };

    fetchData();
    fetchPatientData(uhid_no); // Fetch patient data when uhid_no changes
  }, [uhid_no]);

  useEffect(() => {
    if (uhid_no && hasDraft(DRAFT_KEYS.CONSENT_FOR_ANAESTHESIA, uhid_no)) {
      const saved = loadDraft(DRAFT_KEYS.CONSENT_FOR_ANAESTHESIA, uhid_no);
      if (saved && saved.formData) {
        setFormData(prev => ({ ...prev, ...saved.formData }));
      }
    }
  }, [uhid_no]);

  const [signatureDialogOpen, setSignatureDialogOpen] = useState(false);
  const [currentSignatureRole, setCurrentSignatureRole] = useState('');
  const signaturePadRef = useRef(null);
  const signatureDatetimeMap = {
    scrub_nurse_signature: "scrub_nurse_datetime",
    circulating_nurse_signature: "circulating_nurse_datetime",
    patient_signature: "patient_signature_date_time",
    witness_signature: "witness_signature_date_time",
    doctor_anaesthetist_signature: "doctor_anaesthetist_signature_date_time",
    interpreter_signature: "interpreter_signature_date_time",
    patient_rep_signature: "patient_rep_signature_date_time",
    patient_rep_witness_signature: "patient_rep_witness_date_time",
    patient_rep_doctor_anaesthetist_sign: "patient_rep_doctor_anaesthetist_sign_date_time",
    patient_rep_interpreter_signature: "patient_rep_interpreter_signature_date_time"
  };

  const handleSignatureOpen = (signatureKey) => {
    setCurrentSignatureRole(signatureKey);

    const datetimeKey = signatureDatetimeMap[signatureKey];
    if (datetimeKey) {
      const now = new Date().toISOString().slice(0, 16); // Format for datetime-local
      setFormData((prev) => ({
        ...prev,
        [datetimeKey]: now
      }));
    }

    setSignatureDialogOpen(true);
  };
  const handleDialogClose = () => {
    setSignatureDialogOpen(false);
  };

  const handleSignatureClear = () => {
    signaturePadRef.current.clear();
  };

  const handleSignatureSave = () => {
    const dataURL = signaturePadRef.current.toDataURL();
    setFormData((prevData) => ({
      ...prevData,
      [currentSignatureRole]: dataURL.split(',')[1], // Only for signature fields
      // Do NOT set any *_name field here!
    }));
    setSignatureDialogOpen(false);
  };
  const consultantOptions = [
    "Dr. A. Kumar",
    "Dr. R. Sharma",
    "Dr. S. Mehta",
    "Dr. P. Verma",
    "Dr. N. Rao"
  ];
  const wardBedOptions = [
    // Ward A
    "Ward A - Bed 1",
    "Ward A - Bed 2",
    "Ward A - Bed 3",
    "Ward A - Bed 4",
    "Ward A - Bed 5",

    // Ward B
    "Ward B - Bed 1",
    "Ward B - Bed 2",
    "Ward B - Bed 3",
    "Ward B - Bed 4",
    "Ward B - Bed 5",

    // ICU
    "ICU - Bed 1",
    "ICU - Bed 2",
    "ICU - Bed 3",
    "ICU - Bed 4",
    "ICU - Bed 5",

    // NICU
    "NICU - Bed 1",
    "NICU - Bed 2",
    "NICU - Bed 3",

    // Emergency
    "Emergency - Bed 1",
    "Emergency - Bed 2",
    "Emergency - Bed 3",
    "Emergency - Bed 4",
    "Emergency - Bed 5"
  ];

  const allowedPattern = /^[a-zA-Z.\s]+$/;
  const anaesthesiaOptions = [
    "General anaesthesia with airway management and post-op observation.",
    "Regional block with sedation under continuous monitoring.",
    "Local anaesthesia without sedation for minor procedure.",
    "Combination of regional and general anaesthesia for pain management.",
    "Spinal anaesthesia with close cardiovascular monitoring."
  ];
  const goToVideoRecorder = (formName, uhid_no) => {
    navigate(`/video?form=${encodeURIComponent(formName)}&uhid_no=${encodeURIComponent(uhid_no)}`);
  };
  const [submitStatus, setSubmitStatus] = useState({
    open: false,
    message: "",
    severity: "success"
  });
  const handleShareClick = async () => {
    try {
      // Call API to generate a share token for the given UHID
      const res = await axios.post(`${API_BASE_URL}/generate_for_consent_api_share_token/${uhid_no}`);

      const token = res.data.token;
      const link = `${API_BASE_URL}/consentForAnaesthesia/${uhid_no}?token=${token}`;
      const message = `Dear Doctor,\n\nPlease fill the post-operative analgesia chart:\n\n${link}`;

      // Copy the shareable link to clipboard
      await navigator.clipboard.writeText(link);

      // Show success notification to user
      setSubmitStatus({
        open: true,
        message: "Secure link copied to clipboard!",
        severity: "info",
      });

      // Open WhatsApp chat with pre-filled message (replace phone number if needed)
      const phoneNumber = '+916379605575'; // Replace with the actual phone number
      window.open(`http://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`, '_blank');
    } catch (error) {
      console.error("Error generating share token:", error);

      // Show error notification to user
      setSubmitStatus({
        open: true,
        message: "Failed to generate shareable link",
        severity: "error",
      });
    }
  };
  const doctorGroups = {
    Cardiologists: [
      "Dr. John Smith",
      "Dr. Emily Johnson",
      "Dr. Michael Brown",
      "Dr. Sarah Davis",
      "Dr. William Wilson",
      "Dr. Linda Martinez"
    ],
    Neurologists: [
      "Dr. Robert Lee",
      "Dr. Patricia Taylor",
      "Dr. James Anderson",
      "Dr. Barbara Thomas",
      "Dr. David Jackson",
      "Dr. Susan White"
    ],
    Orthopedics: [
      "Dr. Richard Garcia",
      "Dr. Jennifer Harris",
      "Dr. Charles Clark",
      "Dr. Jessica Lewis",
      "Dr. Thomas Robinson",
      "Dr. Karen Walker"
    ],
    Dermatologists: [
      "Dr. Nancy Young",
      "Dr. Matthew Hall",
      "Dr. Donna Allen",
      "Dr. Steven King",
      "Dr. Michelle Wright",
      "Dr. George Scott"
    ],
    Gynecologists: [
      "Dr. Sandra Green",
      "Dr. Kevin Adams",
      "Dr. Laura Baker",
      "Dr. Mark Nelson",
      "Dr. Angela Carter",
      "Dr. Brian Mitchell"
    ],
    Pediatricians: [
      "Dr. Melissa Perez",
      "Dr. Eric Roberts",
      "Dr. Deborah Turner",
      "Dr. Jason Phillips",
      "Dr. Rebecca Campbell",
      "Dr. Andrew Parker"
    ],
    AnaesthesiaSpecialists: [
      "Dr. Anil Mehta",
      "Dr. Priya Iyer",
      "Dr. Rakesh Nair",
      "Dr. Neha Sharma",
      "Dr. Vivek Rao",
      "Dr. Aarti Desai"
    ]
  };

  return (
    <ThemeProvider theme={theme}>
      <Container maxWidth="md" sx={{ marginTop: 4, marginBottom: 4 }}>
        <Paper elevation={3} sx={{ padding: 3 }}>

          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: 2 }}>
            {/* Heading with Icon */}
            <Typography
              variant="h4"
              sx={{
                color: '#008080',
                display: 'flex',
                alignItems: 'center',
                fontWeight: 600,
                letterSpacing: 0.5,
              }}
            >

              CONSENT FOR ANAESTHESIA
            </Typography>

            {/* Right-aligned Logo and Text */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <img src="/logo.png" alt="Logo" className="w-8 h-8" />
              <Typography
                variant="h6"
                sx={{
                  color: '#008080',
                  marginLeft: 1,
                  fontWeight: 500,
                  letterSpacing: 0.3,
                }}
              >
                OTMS
              </Typography>
            </Box>
          </Box>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 2 }}>
            {/* Left-aligned Back Button */}
            <Button
              variant="outlined"
              onClick={handleBack}
              sx={{ marginLeft: 2 }}
            >
              Back
            </Button>

            {/* Right-aligned Buttons */}
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Button
                variant="contained"
                onClick={handleHomeNavigation}
                sx={{ marginRight: 1 }}
              >
                Home
              </Button>
              <Button
                variant="contained"
                onClick={() => goToVideoRecorder("CONSENT FOR ANAESTHESIA", uhid_no)}
                sx={{ marginRight: 1 }}
              >
                Add Iterative Video
              </Button>
              <IconButton color="primary" aria-label="share" onClick={handleShareClick}>
                <ShareIcon />
              </IconButton>
            </Box>
          </Box>
          <br></br>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          <Grid container spacing={2}>
            {/* Patient Information */}
            <Grid item xs={12} sm={6}>
              <TextField
                label="Patient Name"
                InputProps={{ readOnly: true, }}
                name="patient_name"
                fullWidth
                value={formData.patient_name}
                onChange={handleNameChange}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                label="Age"
                name="age"
                type="number"
                InputProps={{ readOnly: true, }}
                fullWidth
                value={formData.age}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                select
                label="Gender"
                name="sex"
                InputProps={{ readOnly: true, }}
                value={formData.sex}
                onChange={handleChange}
                required
                fullWidth
              >
                <MenuItem value="Male">Male</MenuItem>
                <MenuItem value="Female">Female</MenuItem>
                <MenuItem value="Other">Other</MenuItem>
              </TextField>
            </Grid>
            <Grid item xs={12} sm={6}>

              <FormControl fullWidth error={!!errors.consultant}>
                <InputLabel id="consultant-label">Consultant <span style={{ color: 'red' }}>*</span></InputLabel>
                <Select
                  labelId="consultant-label"
                  id="consultant"
                  name="consultant"
                  value={formData.consultant || ''}
                  required
                  onChange={handleChange}
                  onBlur={handleBlur}
                >
                  <MenuItem value="">
                    <em>Select Consultant</em>
                  </MenuItem>

                  {Object.entries(doctorGroups).map(([specialty, doctors]) => [
                    <ListSubheader key={specialty}>{specialty}</ListSubheader>,
                    doctors.map((doctor, idx) => (
                      <MenuItem key={`${specialty}-${idx}`} value={doctor}>
                        {doctor}
                      </MenuItem>
                    )),
                  ])}
                </Select>
                {errors.consultant && <FormHelperText>{errors.consultant}</FormHelperText>}
              </FormControl>

            </Grid>


            <Grid item xs={6} sm={3}>
              <FormControl fullWidth>
                <InputLabel id="ward-bed-select-label">Ward & Bed No</InputLabel>
                <Select
                  labelId="ward-bed-select-label"
                  id="ward-bed-select"
                  name="ward_bed_no"
                  value={formData.ward_bed_no || ''}
                  label="Ward & Bed No"
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      ward_bed_no: e.target.value,
                    }))
                  }
                >
                  {wardBedOptions.map((option, index) => (
                    <MenuItem key={index} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={3}>
              <TextField
                label="UHID No"
                name="uhid_no"
                fullWidth
                InputProps={{ readOnly: true, }}
                value={formData.uhid_no}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} >
              <TextField
                label="IP No"
                name="ip_no"
                type="number"
                fullWidth
                value={formData.ip_no || ''}
                onChange={handleChange}
                InputProps={{ readOnly: true, }}
              />
            </Grid>
          </Grid>
          <Divider sx={{ my: 2 }} />
          <Grid alignContent={"baseline"} >
            <Typography >
              I <Input style={{ width: "250px" }} value={formData.acknowledge_patient_name} onChange={handleNameChange} name="acknowledge_patient_name"></Input> acknowledge that my doctor has explained to me that I will have an operation, diagnostic
              or treatment procedure. My doctor has explained the cost, risks of the procedure, advised me of the
              alternative treatments and the risks of not having the procedure and told me about the expected outcome and what could
              happen if my condition remains untreated. I also understand that anaesthesia services are needed so that my docfor can
              perform the operation or procedure.

              It has been explained to me that all forms of anaesthesia involve some and no guarantees or promises can be
              made concerming the results of my procedure or treatment. Although rare, unexpected severe complications with
              anaesthesia can occur and include the remote possibility of infection, bleeding, drug reactions, blood clots, loss of sensation,
              loss of limb function, paralysis, stroke, brain damage, heart attack or death. I understand that these risks apply to all forms of
              anaesthesia and that additional or specific risks have been Identified below as they may apply to a specific type of
              anaesthesia. I understand that the type(s) of anaesthesia service checked below will be used for my procedure and that the
              anaesthesia technique to be used is determined by many factors including my physical condition, the type of procedure my
              doctor is to do, his or her preference, as well as my own desire. It has been explained to me that sometimes an anaesthesia
              technique which invoice the use of local anaesthetics, with or without sedation, may not succeed completely and therefore
              another technique may have to be used including general anaesthesia.
            </Typography>
          </Grid>
          <Divider sx={{ my: 2 }} />
          {/* Anesthesia Section */}
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <Typography variant="h6" textAlign={'center'} >Anaesthesia Care Plan</Typography>

              <Autocomplete
                freeSolo
                options={anaesthesiaOptions}
                value={formData.anaesthesia_care_plan}
                onInputChange={(event, newInputValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    anaesthesia_care_plan: newInputValue,
                  }));
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label="Anaesthesia Care Plan"
                    name="anaesthesia_care_plan"
                    fullWidth
                    multiline
                    rows={3}
                    error={!!errors.anaesthesia_care_plan}
                    helperText={errors.anaesthesia_care_plan}
                    onBlur={handleBlur}
                  />
                )}
              />

            </Grid>

          </Grid>
          <Box mt={3}>

            <FormControlLabel
              control={
                <Checkbox
                  name="general_anaesthesia"
                  checked={formData.general_anaesthesia}
                  onChange={handleChange}
                />
              }
              label="General Anaesthesia"
            />
            <Typography variant="body2">
              <h5>Expected Result:</h5>
              Total unconscious state, possible placement of a tube into the
              windpipe
            </Typography>
            <Divider sx={{ my: 2 }} />
            <h5>Technique:</h5>
            <Typography variant="body2">
              Drug injected into the bloodstream, breathed into the lungs, or by
              other routes.
            </Typography>
            <Divider sx={{ my: 2 }} />
            <h5>Risks:</h5>
            <Typography variant="body2">
              Mouth/throat pain, hoarseness, injury to mouth/teeth,
              awareness under anaesthesia, injury to blood vessels, aspiration,
              pneumonia.
            </Typography>
            <Divider sx={{ my: 2 }} />
            <Typography >Spinal or Epidural Analgesia / Anaesthesia</Typography>

            <br></br>


            <FormControlLabel
              control={
                <Checkbox
                  name="spinal_epidural_with_sedation"
                  checked={formData.spinal_epidural_with_sedation}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      spinal_epidural_with_sedation: e.target.checked,
                      spinal_epidural_without_sedation: e.target.checked ? false : prev.spinal_epidural_without_sedation,
                    }));
                  }}
                />
              }
              label="With Sedation"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="spinal_epidural_without_sedation"
                  checked={formData.spinal_epidural_without_sedation}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      spinal_epidural_without_sedation: e.target.checked,
                      spinal_epidural_with_sedation: e.target.checked ? false : prev.spinal_epidural_with_sedation,
                    }));
                  }}
                />
              }
              label="Without Sedation"
            />


            <Typography variant="body2">
              <h5>Expected Result:</h5>
              Temporary decreased or loss of feeling and/ or movement to lower
              part of the body.

            </Typography>
            <Divider sx={{ my: 2 }} />
            <h5>Technique:</h5>
            <Typography variant="body2">
              Drug injucted through a needle / catheter placed either directly into
              the spinal canal or immediately outside the spinal canal.
            </Typography>
            <Divider sx={{ my: 2 }} />
            <h5>Risks:</h5>
            <Typography variant="body2">
              Headache, Backache, buzzing in the ears, convulsions, infection,
              persistent weakness, numbness residual pain, injury to blood
              vessels, "total spinal".
            </Typography>
            <Divider sx={{ my: 2 }} />

            <Typography >Major / Minor Nerve Block</Typography>

            <br></br>
            <FormControlLabel
              control={
                <Checkbox
                  name="major_minor_nerve_with_sedation"
                  checked={formData.major_minor_nerve_with_sedation}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      major_minor_nerve_with_sedation: e.target.checked,
                      major_minor_nerve_without_sedation: e.target.checked ? false : prev.major_minor_nerve_without_sedation,
                    }));
                  }}
                />
              }
              label="With Sedation"
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="major_minor_nerve_without_sedation"
                  checked={formData.major_minor_nerve_without_sedation}
                  onChange={(e) => {
                    setFormData((prev) => ({
                      ...prev,
                      major_minor_nerve_without_sedation: e.target.checked,
                      major_minor_nerve_with_sedation: e.target.checked ? false : prev.major_minor_nerve_with_sedation,
                    }));
                  }}
                />
              }
              label="Without Sedation"
            />

            <Typography variant="body2">
              <h5>Expected Result:</h5>
              Temporary loss of feeling and/or movement of a specific limb or
              area.


            </Typography>
            <Divider sx={{ my: 2 }} />
            <h5>Technique:</h5>
            <Typography variant="body2">
              Drug injucted near to the nerves previding loss of sensation to the area
              of the operation.
            </Typography>
            <Divider sx={{ my: 2 }} />
            <h5>Risks:</h5>
            <Typography variant="body2">
              Infection, convulsions, Persistent numbness, residual pain, injury
              to blood vessels.
            </Typography>
            <Divider sx={{ my: 2 }} />

          </Box>

          {/* Consent Section */}
          <Grid>

            <Typography component="div" sx={{ lineHeight: 1.9 }}>
              I hereby consent to the anaesthesia service checked above and authorize that it be administered by&nbsp;

              <FormControl
                size="small"
                variant="outlined"
                sx={{
                  minWidth: 200,
                  display: "inline-flex",
                  verticalAlign: "middle",
                  '& .MuiSelect-select': {
                    py: 1,
                    px: 2,
                    fontSize: '0.95rem',
                  },
                }}
              >
                <InputLabel id="dr-name-label">Doctor</InputLabel>
                <Select
                  labelId="dr-name-label"
                  name="dr_name"
                  value={formData.dr_name || ""}
                  onChange={handleChange}
                  label="Doctor"
                  onBlur={handleBlur}
                >
                  <MenuItem value="">
                    <em>Select Doctor</em>
                  </MenuItem>
                  {Object.entries(doctorGroups).map(([specialty, doctors]) => [
                    <ListSubheader key={specialty}>{specialty}</ListSubheader>,
                    ...doctors.map((doctor, idx) => (
                      <MenuItem key={`${specialty}-${idx}`} value={doctor}>
                        {doctor}
                      </MenuItem>
                    )),
                  ])}
                </Select>
                {errors.dr_name && <FormHelperText>{errors.dr_name}</FormHelperText>}
              </FormControl>

              &nbsp;or his / her associates; all of whom are credentialed to provide anaesthesia service at Annai Arul Hospitals, Mudichur - Chennai. I also consent to an alternative type of anaesthesia, if necessary, as deemed appropriate by them.
              <br /><br />
              I certify and acknowledge that I have read this form or had it read to me, that I understand the risks, alternatives, and expected results of the anaesthesia service and that I had ample time to ask questions and consider my decision.
            </Typography>
          </Grid>

          <Typography variant="h6" sx={{ marginTop: 3 }}>
            Signatures
          </Typography>
          <Grid container spacing={2}>
            {[
              {
                label: "Patient",
                key: "patient_signature",
                key1: "patient_signature_name",
                key2: "patient_signature_date_time"
              },
              {
                label: "Witness",
                key: "witness_signature",
                key1: "witness_name",
                key2: "witness_signature_date_time"
              },
              {
                label: "Doctor/Anaesthetist",
                key: "doctor_anaesthetist_signature",
                key1: "doctor_anaesthetist_name",
                key2: "doctor_anaesthetist_signature_date_time"
              },
              {
                label: "Interpreter",
                key: "interpreter_signature",
                key1: "interpreter_name",
                key2: "interpreter_signature_date_time"
              }

            ].map((person, index) => (
              <Grid item xs={12} sm={6} key={index}>
                {person.label === "Doctor/Anaesthetist" ? (
                  <FormControl fullWidth sx={{ marginTop: 1 }}>
                    <InputLabel>{`Name (${person.label})`}</InputLabel>
                    <Select
                      name={person.key1}
                      value={formData[person.key1]}
                      onChange={handleNameChange}
                      label={`Name (${person.label})`}
                    >
                      <MenuItem value="">
                        <em>Select Doctor</em>
                      </MenuItem>
                      {doctorGroups["AnaesthesiaSpecialists"]?.map((doctor, idx) => (
                        <MenuItem key={idx} value={doctor}>
                          {doctor}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : (
                  <TextField
                    fullWidth
                    label={`Name (${person.label})`}
                    variant="outlined"
                    value={formData[person.key1]}
                    name={person.key1}
                    sx={{ marginTop: 1 }}
                    onChange={handleNameChange} // This should only allow text
                    error={!!errors[person.key1]}
                    helperText={errors[person.key1]}
                    onBlur={handleBlur}
                  />
                )}

                <TextField fullWidth label="Date" type="DateTime-local" inputProps={{
                  min: new Date().toISOString().slice(0, 16), // Sets the minimum date and time to the current date and time
                }} variant="outlined" sx={{ marginTop: 1 }} value={formData[person.key2]} name={person.key2} onChange={handleChange} InputLabelProps={{ shrink: true, }}
                  error={!!errors[person.key2]}
                  helperText={errors[person.key2]}
                  onBlur={handleBlur}
                />

                <Button variant="outlined" color="primary" sx={{ marginTop: 2 }} onClick={() => handleSignatureOpen(person.key)}> Sign Here </Button>
                {formData[person.key] && <img src={`data:image/png;base64,${formData[person.key]}`} alt="Signature" style={{ marginTop: 10, border: '1px solid black', width: '100%', height: '150px' }} />}
              </Grid>
            ))}
          </Grid>

          <Dialog open={signatureDialogOpen} onClose={() => setSignatureDialogOpen(false)}>
            <DialogTitle>Provide Your Signature</DialogTitle>
            <DialogContent>
              <SignatureCanvas ref={signaturePadRef} canvasProps={{ width: 400, height: 200, className: 'sigCanvas' }} />
            </DialogContent>

            <DialogActions>
              <Button onClick={handleDialogClose} >close</Button>
              <Button onClick={handleSignatureClear} color="secondary">Clear</Button>
              <Button onClick={handleSignatureSave} color="primary">Done</Button>
            </DialogActions>
          </Dialog>

          <Divider sx={{ my: 2 }} />
          <Box sx={{ mt: 4, p: 3, border: '1px solid #ccc', borderRadius: '8px', backgroundColor: '#f9f9f9' }}>
            <Typography variant="h6" sx={{ mb: 2, fontWeight: 'bold', textAlign: 'center' }}>CONSENT OF PATIENT REPRENSETATIVE / SURROGATE / Children below 18 yrs / vulnearble patients</Typography>
            <Typography variant="body1" sx={{ mb: 1 }}>
              The patient is unable to consent because:
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <Autocomplete
                freeSolo
                options={unableConsentReasons}
                value={formData.unable_consent_reason}
                onInputChange={(event, newInputValue) => {
                  setFormData((prev) => ({
                    ...prev,
                    unable_consent_reason: newInputValue,
                  }));
                }}
                sx={{ flex: 1 }}  // Make autocomplete take equal space
                renderInput={(params) => (
                  <TextField
                    {...params}
                    name="unable_consent_reason"
                    label="Reason Unable to Consent"
                    variant="outlined"
                    fullWidth  // ensure it fills its container
                  />
                )}
              />

              <Typography variant="body1" sx={{ mx: 2, whiteSpace: 'nowrap' }}>
                And I,
              </Typography>

              <TextField
                name="attender_name"
                label="Attender Name"
                value={formData.attender_name}
                onChange={handleNameChange}
                variant="outlined"
                sx={{ flex: 1 }}
                fullWidth  // ensure it fills its container
              />
            </Box>


            <Typography variant="body1">
              (name/relationship to the patient) therefore consent for the
              procedure with the doctor's designee and hereby consent to this procedure.
            </Typography>
          </Box>
          <Divider sx={{ my: 2 }} />
          <Typography variant="h6" sx={{ marginTop: 3 }}>
            Signatures
          </Typography>
          <Grid container spacing={2}>
            {[
              {
                label: "Patient Representative with relationship",
                key: "patient_rep_signature",
                key1: "patient_rep_name",
                key2: "patient_rep_signature_date_time"
              },
              {
                label: "Witness",
                key: "patient_rep_witness_signature",
                key1: "patient_rep_witness_name",
                key2: "patient_rep_witness_date_time"
              },
              {
                label: "Doctor/Anaesthetist",
                key: "patient_rep_doctor_anaesthetist_sign",
                key1: "patient_rep_doctor_anaesthetist_name",
                key2: "patient_rep_doctor_anaesthetist_sign_date_time"
              },
              {
                label: "Interpreter",
                key: "patient_rep_interpreter_signature",
                key1: "patient_rep_interpreter_name",
                key2: "patient_rep_interpreter_signature_date_time"
              }

            ].map((person, index) => (
              <Grid item xs={12} sm={6} key={index}>
                {person.label === "Doctor/Anaesthetist" ? (
                  <FormControl fullWidth sx={{ marginTop: 1 }}>
                    <InputLabel>{`Name (${person.label})`}</InputLabel>
                    <Select
                      name={person.key1}
                      value={formData[person.key1]}
                      onChange={handleNameChange}
                      label={`Name (${person.label})`}
                    >
                      <MenuItem value="">
                        <em>Select Doctor</em>
                      </MenuItem>
                      {doctorGroups["AnaesthesiaSpecialists"]?.map((doctor, idx) => (
                        <MenuItem key={idx} value={doctor}>
                          {doctor}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                ) : (
                  <TextField
                    fullWidth
                    label={`Name (${person.label})`}
                    variant="outlined"
                    value={formData[person.key1]}
                    name={person.key1}
                    sx={{ marginTop: 1 }}
                    onChange={handleNameChange} // This should only allow text
                    error={!!errors[person.key1]}
                    helperText={errors[person.key1]}
                    onBlur={handleBlur}
                  />
                )}

                <TextField fullWidth label="Date" type="DateTime-local" inputProps={{
                  min: new Date().toISOString().slice(0, 16), // Sets the minimum date and time to the current date and time
                }} variant="outlined" sx={{ marginTop: 1 }} value={formData[person.key2]} name={person.key2} onChange={handleChange} InputLabelProps={{ shrink: true, }}
                  error={!!errors[person.key2]}
                  helperText={errors[person.key2]}
                  onBlur={handleBlur}
                />
                <Button variant="outlined" color="primary" sx={{ marginTop: 2 }} onClick={() => handleSignatureOpen(person.key)}> Sign Here </Button>
                {formData[person.key] && <img src={`data:image/png;base64,${formData[person.key]}`} alt="Signature" style={{ marginTop: 10, border: '1px solid black', width: '100%', height: '150px' }} />}
              </Grid>
            ))}
          </Grid>

          <Dialog open={signatureDialogOpen} onClose={() => setSignatureDialogOpen(false)}>
            <DialogTitle>Provide Your Signature</DialogTitle>
            <DialogContent>
              <SignatureCanvas ref={signaturePadRef} canvasProps={{ width: 400, height: 200, className: 'sigCanvas' }} />
            </DialogContent>
            <DialogActions>
              <Button onClick={handleDialogClose} >close</Button>
              <Button onClick={handleSignatureClear} color="secondary">Clear</Button>
              <Button onClick={handleSignatureSave} color="primary">Done</Button>
            </DialogActions>
          </Dialog>
          <Divider sx={{ my: 2 }} />
          <Grid item xs={12}>
            <Box sx={{ display: 'flex', gap: 2, marginTop: 3 }}>
              <DraftSaveButton
                formKey={DRAFT_KEYS.CONSENT_FOR_ANAESTHESIA}
                uhidNo={uhid_no}
                formData={formData}
                onDraftLoaded={(draftData) => setFormData(draftData)}
                variant="outlined"
                size="large"
                isUpdate={success}
              />
              {/* Submit Button */}
              <Button type="submit" variant="contained" color="primary" sx={{ marginTop: 3 }} fullWidth onClick={handleSubmit}>
                {success ? 'Update' : 'Submit'}
              </Button>
            </Box>

            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

          </Grid>
        </Paper>
      </Container>
    </ThemeProvider>
  );
};

export default AnaesthesiaConsentForm;
